import React, { useEffect } from "react";
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@material-ui/core";

import { appRoutes, externalRoutes } from "routes";
import { useRouter, useTransactionRecords } from "hooks";
import Placeholder from "components/Placeholder";
import AccountLayout from "layouts/AccountLayout";
import TransactionRecordPresenter from "presenters/TransactionRecordPresenter";
import MetaTags from "components/MetaTags";

import { Title } from "../components";

import useStyles from "./useStyles";

const Receipt = () => {
  const classes = useStyles();
  const {
    query: { id },
  } = useRouter();
  const { loadTransactionRecord, transactionRecord } = useTransactionRecords();

  useEffect(() => {
    loadTransactionRecord(id);
  }, [id]);

  return (
    <>
      <style>
        {`@media print {
          body {
            position: fixed;
          }
          body * {
            visibility: hidden;
          }
          #printable, #printable * {
            visibility: visible;
          }
          #printable .print-hide, #printable .print-hide * {
            display: none;
          }
        }`}
      </style>

      <AccountLayout
        title="Funny eCards - Send Custom Greeting Cards Online w/ JibJab! - My Account - Receipt "
        backLink={appRoutes.receiptsPath()}
      >
        <div id="printable">
          <Title title="JibJab Receipt" />

          <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="a dense table">
              <TableBody>
                <TableRow>
                  <TableCell align="right" className={classes.cell}>
                    Date:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {!transactionRecord && <Placeholder variant="text" width={150} />}
                    {transactionRecord && <b>{TransactionRecordPresenter.paidAtDate(transactionRecord)}</b>}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" className={classes.cell}>
                    Transaction:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {!transactionRecord && <Placeholder variant="text" width={150} />}
                    {transactionRecord && <b>{transactionRecord.id}</b>}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" className={classes.cell}>
                    Description:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {!transactionRecord && <Placeholder variant="text" width={150} />}
                    {transactionRecord && <b>{TransactionRecordPresenter.description(transactionRecord)}</b>}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" className={classes.cell}>
                    Amount:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {!transactionRecord && <Placeholder variant="text" width={150} />}
                    {transactionRecord && <b>{TransactionRecordPresenter.price(transactionRecord)}</b>}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <Button variant="contained" color="secondary" className={classes.button} onClick={() => window.print()}>
          Print
        </Button>

        <Typography variant="caption" display="block">
          If you have any questions regarding this receipt, please{" "}
          <a href={externalRoutes.helpPath()} target="_blank" rel="noreferrer">
            visit our Support Center for Help
          </a>
        </Typography>
      </AccountLayout>
      <MetaTags>
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

export default Receipt;
